import Modal from 'react-modal';
import React, { useEffect, useState } from 'react';
import styles from './AddExtraIncomeModal.module.css';
import { ExtraIncome } from '../types';
import { fetchWithAuth } from '../util/fetchWithAuth';
import { toast } from 'react-toastify';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  extraIncome: ExtraIncome | null;
};

const MarkExtraIncomeAsPaidModal: React.FC<Props> = ({ isOpen, onClose, onSuccess, extraIncome }) => {
  const [paymentDate, setPaymentDate] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      setPaymentDate('');
      setError('');
    }
  }, [isOpen]);

  const handleSave = async () => {
    if (!paymentDate) {
      setError('Payment date is required.');
      return;
    }
    if (!extraIncome) return;

    try {
      const res = await fetchWithAuth(`/extra_incomes/${extraIncome.id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ payment_date: paymentDate }),
      });

      if (res.ok) {
        toast.success('Extra income marked as paid.');
        onSuccess();
        onClose();
      } else {
        toast.error('Failed to mark extra income as paid.');
      }
    } catch {
      toast.error('An unexpected error occurred.');
    }
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} className={styles.modalContent}>
      <h2 className="text-2xl font-bold mb-4">Mark as Paid</h2>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">Payment Date</label>
          <input
            type="date"
            value={paymentDate}
            onChange={(e) => {
              setPaymentDate(e.target.value);
              setError('');
            }}
            className="w-full px-3 py-2 border rounded"
          />
          {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
        </div>
      </div>
      <div className="mt-6 flex justify-end">
        <button
          onClick={onClose}
          className="mr-4 px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300"
        >
          Cancel
        </button>
        <button
          onClick={handleSave}
          className="px-4 py-2 bg-black text-white rounded hover:bg-gray-800"
        >
          Save
        </button>
      </div>
    </Modal>
  );
};

export default MarkExtraIncomeAsPaidModal;
